import { render, staticRenderFns } from "./referenciaOXXO.vue?vue&type=template&id=b888d2f4&scoped=true&"
import script from "./referenciaOXXO.vue?vue&type=script&lang=js&"
export * from "./referenciaOXXO.vue?vue&type=script&lang=js&"
import style0 from "./referenciaOXXO.vue?vue&type=style&index=0&id=b888d2f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b888d2f4",
  null
  
)

export default component.exports